import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { SystemSection } from '../components/SystemSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProcessSection } from '../components/ProcessSection';
import { SocialProof } from '../components/SocialProof';
import { FAQSection } from '../components/FAQSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="min-h-screen w-full flex flex-col" data-id="element-175">
      <HeroSection data-id="element-176" />
      <StorySection data-id="element-177" />
      <SystemSection data-id="element-178" />
      <AudienceSection data-id="element-179" />
      <ProcessSection data-id="element-180" />
      <SocialProof data-id="element-181" />
      <FAQSection data-id="element-182" />
      <OfferSection data-id="element-183" />
      <Footer data-id="element-184" />
    </main>;
}